import React from 'react'
import { Tag } from 'antd'
import { basicDeleteActionField } from '../../../../components/table/fields/common'
import { configureField } from '../../../../core/utils/list'

export const basicColumns = (props) => {
  const { toggle, loading, filters, resize, hidden, actionLoading } = props

  if (loading) return []

  return [
    {
      title: 'Code',
      dataIndex: 'code',
      render: (name, record) => <>{name}</>,
      ...configureField('l.code', filters, resize, hidden, true, false, false, 200)
    },
    {
      title: 'Name',
      dataIndex: 'name',
      ...configureField('l.name', filters, resize, hidden, true, false, true, 200)
    },
    {
      title: 'Directionality',
      dataIndex: 'directionality',
      ...configureField('l.directionality', filters, resize, hidden, true, false, true, 200)
    },

    {
      title: 'Status',
      dataIndex: 'active',
      ...configureField('l.active', filters, resize, hidden, true, false, true, 200),
      render: (check) => (
          <>{check ? <Tag color='green'> ENABLED </Tag> : <Tag color='volcano'> DISABLED </Tag>}</>
      )
    },
    {
      ...basicDeleteActionField({ toggle, loading: actionLoading }),
      visible: true,
      width: 200
    }
  ]
}
